<template>
  <div class="earnings-root">
      <div>
        <div class="common-space-around">
            <div class="yuedyu common-items-center">
              <div class="common-items-center" @click="tabBtn">
                 <img class="checked" v-if="show" src="@/assets/checked.svg" alt="">
                 <img class="checked" v-else src="@/assets/checkedNo.svg" alt="">
              </div>
              <span>阅读并同意</span>
              <span @click="downPOIBtn" style="color:#367CFF;cursor:pointer;">《POI信息服务协议》</span>   
              <span>和</span>
              <span @click="downPOIBtnB" style="color:#367CFF;cursor:pointer;">《繁淼平台商户合作协议》</span>  
            </div>
        </div>
        <div class="earnings-btn">
          <div class="btn-box" @click="BtnSubmitBtn">
            <span>提交资质</span>
          </div>
        </div>`
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
        show:false
    }
    
  },
  created(){
    if(!!localStorage.getItem("showMARK")){
        this.show = localStorage.getItem("showMARK")
    }else{
        this.show = true
    }
  },
  methods:{

      tabBtn(){
        this.show = !this.show
        localStorage.setItem("showMARK",this.show)
      },

      //下载POI
      downPOIBtn(){
          let a = document.createElement('a');
          let evt = document.createEvent('MouseEvents');
          a.download = 'Protocol.doc';
          a.href = '/Protocol.doc';
          evt.initEvent('click',true,true);
          a.dispatchEvent(evt);
          window.URL.revokeObjectURL(a.href);
      },
      //下载合作协议
      downPOIBtnB(){
          let a = document.createElement('a');
          let evt = document.createEvent('MouseEvents');
          a.download = 'hezuo.doc';
          a.href = '/hezuo.doc';
          evt.initEvent('click',true,true);
          a.dispatchEvent(evt);
          window.URL.revokeObjectURL(a.href);
      },


      //提交
      BtnSubmitBtn(){
          this.$emit("BtnSubmitBtn")
      },




	}
}
</script>

<style lang="scss" scoped>
  .earnings-root{
      padding-top:120px; 
      .yuedyu{
         font-size: 14px;
         font-family: PingFangSC, PingFang SC;
         font-weight: 400;
         color: #333333;
         text-align:center;
         .checked{
            margin-right:10px;
         }
      }
      .earnings-btn{
        width: 1200px;
        display: flex;
        justify-content: center;
        padding-bottom:120px;
        padding-top:40px;
        margin: 0 auto;
        .btn-box{
          width: 188px;
          height: 52px;
          background: #367CFF;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all .3s;
          &:hover{
            opacity: .7;
          }
          span{
            font-size: 20px;
            font-family: Alibaba_Bold;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 28px;
          }
        }
      }
    }
  
</style>